






























































import { defineComponent } from '@nuxtjs/composition-api'
import CImg from '~/components/shared/configurable/image/CImg.vue'
import CPicture from '~/components/shared/configurable/image/CPicture.vue'
import { defineComponentTranslations } from '~/utils/i18n'

export default defineComponent({
  components: { CPicture, CImg },
  i18n: defineComponentTranslations({
    need_service: {
      en: 'Need Service?',
      el: 'Χρειάζεσαι Service;'
    },
    book_appointment: {
      en: 'book',
      el: 'κλείσε'
    },
    through: {
      en: 'through',
      el: 'μέσω'
    }
  })
})
